import { createFileRoute } from "@tanstack/react-router";
import { SearchPage } from "@/components/search/SearchPage";
import { searchSeo } from "@/lib/page-seo";

export const Route = createFileRoute("/search")({
  validateSearch: (search: Record<string, unknown>) => ({
    q: typeof search.q === "string" ? search.q : undefined,
  }),
  loader: ({ location }) => ({ href: location.href }),
  head: ({ loaderData }) => searchSeo(loaderData?.href ?? "/search"),
  component: SearchRouteComponent,
});

function SearchRouteComponent() {
  const { q } = Route.useSearch();
  return <SearchPage initialQuery={q ?? ""} />;
}
